module.exports = __webpack_public_path__ + "img/ceo-img.f73f9786.png";